exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbotron {\r\n  background-color:#2E2D88;\r\n  color: white;\r\n}\r\n\r\n.tab-content {\r\n  border-left: 1px solid #ddd;\r\n  border-right: 1px solid #ddd;\r\n  border-bottom: 1px solid #ddd;\r\n  padding: 10px;\r\n}\r\n\r\n.nav-tabs {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.panel-default {\r\n  padding: 10px;\r\n}\r\n\r\n.media-heading {\r\n  font-weight: bold !important;\r\n  font-size: 17px;\r\n  margin-top: 5px;\r\n}\r\n\r\n.media-info {\r\n  font-weight: 500 !important;\r\n}\r\n\r\n.cc-search {\r\n  margin-left: 15px;;\r\n}\r\n\r\n.video-checkbox {\r\n  margin-left: 5px;\r\n}\r\n\r\n.heading-spacing {\r\n  position: relative;\r\n  top: 34px;\r\n}\r\n\r\n.save-buttons {\r\n  margin-top: 5px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.spacer {\r\n  margin-bottom: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/media/media.component.css
// module id = ../../../../../src/app/media/media.component.css
// module chunks = 1